var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('myHeader'),_c('Description',{attrs:{"width":_vm.width}}),_c('PortfolioContainer',{attrs:{"width":_vm.width}}),_c('ReciewsContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }